import { render, staticRenderFns } from "./riskIdentificationDetail.vue?vue&type=template&id=791f62e0&scoped=true"
import script from "./riskIdentificationDetail.vue?vue&type=script&lang=js"
export * from "./riskIdentificationDetail.vue?vue&type=script&lang=js"
import style0 from "./riskIdentificationDetail.vue?vue&type=style&index=0&id=791f62e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791f62e0",
  null
  
)

export default component.exports